import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/download/page.tsx");
